import { Alert } from '@mui/material'
import Collapse from '@mui/material/Collapse';
import classes from './ErrorAlert.module.css'


import React from 'react'

function ErrorAlert({ error }) {
    return (
        <div className={classes.container} >
            <Collapse in={Boolean(error)}>
                <Alert
                    severity="error" sx={{
                        alignItems: 'center'
                    }}
                >
                    {error}
                </Alert>
            </Collapse>

        </div>
    )
}

export default ErrorAlert